export const CREATE_BOARD_ACCESS_OPTIONS = [
  {
    label: "Private",
    value: "true",
  },
  {
    label: "Public",
    value: "false",
  },
];

export function sortBoardsByName(boards = []) {
  return [...boards].sort((a, b) => a.board_name.localeCompare(b.board_name));
}

export function filterBoardsBySearch(boards = [], searchText = "") {
  const normalizedSearch = `${searchText || ""}`.toLowerCase();

  return boards.filter((board) =>
    board.board_name.toLowerCase().includes(normalizedSearch)
  );
}

export function getActiveBoards(boards = []) {
  return sortBoardsByName(boards.filter((board) => !board.is_archive));
}

export function getDashboardBoardSections({
  boards = [],
  searchText = "",
  includeAdminSections = false,
}) {
  const searchedBoards = filterBoardsBySearch(sortBoardsByName(boards), searchText);

  return {
    userBoards: searchedBoards.filter(
      (board) => !board.is_archive && board.is_super_admin_and_board_user
    ),
    allBoards: includeAdminSections
      ? searchedBoards.filter((board) => !board.is_archive)
      : [],
    archivedBoards: includeAdminSections
      ? searchedBoards.filter((board) => board.is_archive)
      : [],
  };
}

export function getWorkflowOptions(workflows) {
  return (
    workflows?.data?.data?.responseData?.map((workflow) => ({
      label: workflow.workflow_name,
      value: workflow.workflow_id,
    })) || []
  );
}

export function getActiveUserOptions(users) {
  return sortUsersByFirstName(
    users?.data?.data?.responseData?.filter((user) => user.active) || []
  ).map((user) => ({
    label: `${user.first_name} ${user.last_name}`,
    value: user.user_id,
  }));
}

export function normalizeCreateBoardPayload(data) {
  return {
    ...data,
    is_private: data?.is_private === "true",
  };
}

function sortUsersByFirstName(users = []) {
  return [...users].sort((a, b) => a.first_name.localeCompare(b.first_name));
}
